import { DEFAULT_TIMEOUT } from "../core/request";
import type { ResponseSchema } from "./types";

export type ParamValue =
  | number
  | string
  | undefined
  | null
  | boolean
  | Array<number | string | boolean>;
export type HeaderValue = string | undefined | null | number | Array<string | number | boolean>;
export type AjaxParamWithoutBody = {
  params?: Record<string, ParamValue>;
  path?: string;
  headers?: Record<string, HeaderValue>;
  responseSchema?: ResponseSchema;
  responseType?: XMLHttpRequestResponseType;
};
export type AjaxParamWithBody = {
  params?: Record<string, ParamValue>;
  body?: any;
  data?: any; // compatible field
  path?: string;
  headers?: Record<string, HeaderValue>;
  responseSchema?: ResponseSchema;
  responseType?: XMLHttpRequestResponseType;
};
export type AjaxParam = AjaxParamWithoutBody | AjaxParamWithBody;

export class OpenAPI {
  public timeout: number | undefined = DEFAULT_TIMEOUT;
  public getDefaultRegion: () => string | undefined = () => undefined;
  private _baseUrl: string = "";

  constructor(baseUrl: string, public base: AjaxParam = {}) {
    this.baseUrl = baseUrl;
    this.build = this.build.bind(this);
  }

  get baseUrl() {
    return this._baseUrl;
  }

  set baseUrl(v: string) {
    this._baseUrl = `${v}/`.replace(/\/{2,}/g, "/");
  }

  build(method: string, action: string, region?: string, p?: AjaxParam) {
    const { params, body, data, headers, ...rest } = p || ({} as any);
    const r = region ?? this.getDefaultRegion();

    return {
      url: this.baseUrl,
      method,
      timeout: this.timeout,
      params: {
        Action: action,
        Region: r, // some api (like kec) needs `Region`
        ...this.base.params,
        ...params,
      },
      data: body || data,
      headers: {
        "X-KSC-REGION": r,
        ...this.base.headers,
        ...headers,
      },
      ...rest,
    };
  }

  get(action: string, region?: string, p?: AjaxParamWithoutBody) {
    return this.build("GET", action, region, p);
  }

  post(action: string, region?: string, p?: AjaxParam) {
    return this.build("POST", action, region, p);
  }
}

// api.get<>(action, params).sendTo(region);
